import { Channel } from "./v1";
import { ChannelV2 } from "./v2";

export type ChannelV1Type = keyof typeof Channel;
export type ChannelV2Type = keyof typeof ChannelV2;

export type ChannelType = ChannelV1Type | ChannelV2Type;
